import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import USERS from 'constants/users';
import CaseLabel from 'containers/CaseCave/CaseDetails/CaseLabels/CaseLabel';
import { Typography } from 'ravenjs/lib';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    flex-wrap: wrap;
    row-gap: 4px;
`;

const PrimaryAccountNameCell = ({ row }) => {
    const { partnerName, isPrimaryCompany } = row || {};

    return (
        <NameWrapper>
            <Typography style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: '14px' }}>
                {partnerName}
            </Typography>
            {isPrimaryCompany && (
                <CaseLabel
                    title={USERS.SWITCH_ACCOUNT_MODAL.PRIMARY_ACCOUNT}
                    color={MIGRATED_COLORS.green3}
                    fontColor={MIGRATED_COLORS.white}
                    fontSize="12px"
                    style={{
                        fontWeight: '500',
                        fontFamily: 'Roboto',
                        padding: '6px 12px',
                        height: '30px',
                        borderRadius: '50px',
                        marginRight: '0px',
                        minWidth: 'fit-content',
                    }}
                />
            )}
        </NameWrapper>
    );
};

PrimaryAccountNameCell.propTypes = {
    row: PropTypes.object,
};

PrimaryAccountNameCell.defaultProps = {
    row: {},
};

export default PrimaryAccountNameCell;
